import { render } from "./QariForm.vue?vue&type=template&id=4061899e"
import script from "./QariForm.vue?vue&type=script&lang=js"
export * from "./QariForm.vue?vue&type=script&lang=js"
script.render = render

export default script